import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class EnterpriseService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  scaleupData: any;

  private scaleupHeroSubject$ = new BehaviorSubject<any>(null);
  public scaleupHero$ = this.scaleupHeroSubject$.asObservable();
  private scaleupCustomerStatsSubject$ = new BehaviorSubject<any>(null);
  public scaleupCustomerStats$ =
    this.scaleupCustomerStatsSubject$.asObservable();
  private scaleupFeaturePanel1Subject$ = new BehaviorSubject<any>(null);
  public scaleupFeaturePanel1$ =
    this.scaleupFeaturePanel1Subject$.asObservable();
  private scaleupFeaturePanel2Subject$ = new BehaviorSubject<any>(null);
  public scaleupFeaturePanel2$ =
    this.scaleupFeaturePanel2Subject$.asObservable();
  private scaleupWhitePaperPanelSubject$ = new BehaviorSubject<any>(null);
  public scaleupWhitePaperPanel$ =
    this.scaleupWhitePaperPanelSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();

  getEnterprisePageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.companySizes,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.scaleupData = mod.filter(
          x => x?.fields['id'] == PageId.enterprisePage
        );
        const heroData = this.scaleupData[0].fields.heroContentPanel.fields;
        if (heroData) {
          this.scaleupHeroSubject$.next(heroData);
        }
        const customerStats =
          this.scaleupData[0].fields.customersStatsContentPanel.fields;
        if (customerStats) {
          this.scaleupCustomerStatsSubject$.next(customerStats);
        }
        const featurePanel1 =
          this.scaleupData[0]?.fields?.psFeatures[0]?.fields;
        if (featurePanel1) {
          this.scaleupFeaturePanel1Subject$.next(featurePanel1);
        }
        const featurePanel2 =
          this.scaleupData[0]?.fields?.psFeatures2[0]?.fields;
        if (featurePanel2) {
          this.scaleupFeaturePanel2Subject$.next(featurePanel2);
        }
        const whitePaperPanel =
          this.scaleupData[0]?.fields?.psWhitepaperForm?.fields;
        if (whitePaperPanel) {
          this.scaleupWhitePaperPanelSubject$.next(whitePaperPanel);
        }
        const getStarted =
          this.scaleupData[0].fields.getStartedContentPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }
}
